import { render } from "./AdminReplenishmentPanel.vue?vue&type=template&id=62b5fb1e&scoped=true"
import script from "./AdminReplenishmentPanel.vue?vue&type=script&lang=js"
export * from "./AdminReplenishmentPanel.vue?vue&type=script&lang=js"

import "./AdminReplenishmentPanel.vue?vue&type=style&index=0&id=62b5fb1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b5fb1e"]])

export default __exports__